exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".whitelist-content[data-v-3cabc374]{width:520px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3cabc374&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/whitelist/newWhiteList.vue
// module id = 499
// module chunks = 0